<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">Buscar Artesanias por lotes o grupos productivos</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/artesania" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agrega actividad artesanal
        </v-btn>
      </v-col>
      <!-- listado de actividades artesanales en el almacenamiento local -->
      <v-col cols="12">
        <v-list three-line>
          <template v-for="artesania in artesanias">
            <form-card
              :key="artesania.id"
              :top-text="`Finca • ${getNombreDeFinca(artesania.id_finca)}`"
              :bottom-text="`Ciclo ${artesania.ciclo}`"
              :middle-text="artesania.descripcion"
              :top-right-text="artesania.fecha"
              :bottom-right-text="producerDescription(artesania.productor)"
              :sincronized="artesania.sincronizado"
              @click="traerRegistroYNavegar(artesania)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Cosechas',
  computed: {
    ...mapState('registros', ['artesanias']),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Artesanias')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getArtesania', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/artesania/${registro.id}`)
    },
  },
}
</script>
